"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MenuItem = exports.useMenuItemProps = exports.ID_ATTRIBUTE_NAME = void 0;
const tslib_1 = require("tslib");
const react_1 = tslib_1.__importStar(require("react"));
const compound_components_1 = require("@clds/compound-components");
const item_1 = require("@clds/item");
const childData_1 = require("./childData");
// https://github.com/microsoft/TypeScript/issues/47663
exports.ID_ATTRIBUTE_NAME = 'data-selectable-id';
const useMenuItemProps = (_a) => {
    var { onClick, id: idProvided } = _a, rest = tslib_1.__rest(_a, ["onClick", "id"]);
    const listStyle = (0, compound_components_1.useListStyle)();
    // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
    const id = (0, compound_components_1.useUniqueId)(idProvided);
    const childData = (0, react_1.useMemo)(() => ({ onClick }), [onClick]);
    (0, childData_1.useRegisterChildData)(id, childData);
    const _b = (0, compound_components_1.useListSelection)(id), { onClick: onClickListSelection } = _b, selection = tslib_1.__rest(_b, ["onClick"]);
    const onClickCombined = (0, compound_components_1.mergeCallbacks)(onClickListSelection, onClick);
    // TODO currently we don't want to show menu items focused and selected at the same time
    // this is because after clicking the menu it receives both focused and selected and you expect just the normal state
    // we should find the way to indicate focused&selected only after the keyboard interaction
    const shouldFocusedBeIndicated = selection.isFocused && selection.isSelected ? false : selection.isFocused;
    return Object.assign(Object.assign(Object.assign(Object.assign({ 
        // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
        [exports.ID_ATTRIBUTE_NAME]: id }, listStyle), selection), { isFocused: shouldFocusedBeIndicated, onClick: onClickCombined }), rest);
};
exports.useMenuItemProps = useMenuItemProps;
const MenuItem = (_a) => {
    var { children } = _a, rest = tslib_1.__rest(_a, ["children"]);
    const listItemProps = (0, exports.useMenuItemProps)(rest);
    return react_1.default.createElement(item_1.Item, Object.assign({}, listItemProps), children);
};
exports.MenuItem = MenuItem;
//# sourceMappingURL=MenuItem.js.map